import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Header from "../Component/Header";
import Footer from "../Component/Footer";

const tabs = [
  "PT-1",
  "PT-2",
  "Half Yearly Examination",
  "PT-3",
  "Annual Examination",
];

const CLASS_RANK = {
  class9: 0,
  classix: 0,
  class10: 1,
  classx: 1,
  class11: 2,
  classxi: 2,
  class12: 3,
  classxii: 3,
};

function classRank(label) {
  const key = String(label).toLowerCase().replace(/[^a-z0-9]/g, "");
  return CLASS_RANK[key] ?? 99;
}

function sortByClass(items) {
  return [...items].sort((a, b) => classRank(a.classLabel) - classRank(b.classLabel));
}

const syllabusByTab = {
  "PT-1": [],
  "PT-2": [],
  "Half Yearly Examination": [
    {
      classLabel: "Class 9",
      fileName:
        "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/STPSFH/public/pdf/syllabus/Secondary_Stage/Half_yearly/Class_IX_half_yearly_syllabus.pdf",
    },
    {
      classLabel: "Class 10",
      fileName:
        "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/STPSFH/public/pdf/syllabus/Secondary_Stage/Half_yearly/Class_X_half_yearly_syllabus.pdf",
    },
    {
      classLabel: "Class 11",
      fileName:
        "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/STPSFH/public/pdf/syllabus/Secondary_Stage/Half_yearly/Class_XI_Half_Yearly_Syllabus.pdf",
    },
  ],
  "PT-3": [],
  "Annual Examination": [],
};

function pdfHref(fileName) {
  return encodeURI(`${fileName}`);
}

function SecondaryStage() {
  const [tab, setTab] = useState("PT-1");
  const syllabusItems = sortByClass(syllabusByTab[tab] || []);

  useEffect(() => {
    document.title =
      "Secondary Stage (IX–XII) - St Peters Convent School Faridabad Haryana";
  }, []);

  return (
    <>
      <Header />
      <div className="innerslide">
        <ul className="breadcrumb">
          <li>
            <Link to="/">Home</Link>
          </li>
          <li>Academics</li>
          <li>Syllabus</li>
          <li>Secondary Stage (IX–XII)</li>
        </ul>
      </div>

      <div className="innersec">
        <div className="container">
          <div className="row mb-4">
            <div className="col-12">
              <h1 className="fw-bold">Secondary Stage (IX–XII)</h1>
            </div>
          </div>

          <nav>
            <div className="nav nav-tabs" role="tablist">
              {tabs.map((name) => (
                <button
                  key={name}
                  type="button"
                  role="tab"
                  className={`nav-link${tab === name ? " active" : ""}`}
                  aria-selected={tab === name}
                  onClick={() => setTab(name)}
                >
                  {name}
                </button>
              ))}
            </div>
          </nav>

          <div className="row mt-4">
            {syllabusItems.map((item) => (
              <div className="col-lg-3 col-md-6 mb-4" key={item.fileName}>
                <div className="card syllabus-card h-100 text-center">
                  <div className="card-body">
                    <div className="pdf-icon mb-3">📄</div>
                    <h6 className="fw-semibold">{item.classLabel}</h6>
                    <a
                      href={pdfHref(item.fileName)}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="click-text"
                    >
                      Click Here →
                    </a>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default SecondaryStage;
